import React from 'react';

const Robot = () => {
    return (
        <div>
            
        </div>
    );
}

export default Robot;
